<template>
  <!--  合同范本下载列表页 -->

  <div class="hdcht">
    <div class="htfb_banner">
      <img src="../../assets/jpcol/htfb_banner_sample.png" />
    </div>
    
    <section class="mt50"><hdcgthtsx /> </section>
    <section class="mt50"><hdchthtlist /> </section>
  </div>
</template>

<script>
import hdcgthtsx from './child/hdcgthtsx'
import hdchthtlist from './child/hdchthtlist'
export default {
    components:{
        hdcgthtsx,
        hdchthtlist
    },
};
</script>

<style lang="scss" scoped>
.hdcht {
  background: #f8f8f8;
  .htfb_banner {
    max-width: 1920px;
    width: 100%;
    overflow: hidden;
    margin: 0 auto;
    img {
      width: 1920px;
    }
  }
}
</style>